export default __webpack_public_path__ + "static/media/spinner.fe483b7c.gif";